
import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumb } from "antd";
import navBarStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import titleStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle";
import cardStyles from "assets/jss/material-dashboard-pro-react/components/cardStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
// core components
import GridItem from "components/Grid/GridItem.js";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ErrorModal from "../../../Components/ErrorModal";

import TableViewIcon from '@mui/icons-material/TableView';
import ViewListIcon from '@mui/icons-material/ViewList';

import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { DataGrid } from "@mui/x-data-grid";
import { unwrapResult } from "@reduxjs/toolkit";
import { Select } from "antd";
import { fetchStaff } from "reduxToolkit/features/user/UserSlice";
import { fetchAllProfessionalDevelopmentActivities } from "../../../../reduxToolkit/features/ProfessionalDevelopment/ProfessionalDevelopmentSlice";
const { Option } = Select;

const useStyles = makeStyles(styles);
const useNavBarStyles = makeStyles(navBarStyles);
const useTitleStyles = makeStyles(titleStyles);
const useCardStyles = makeStyles(cardStyles);

export default function AllProfessionalDevelopmentActivities() {

  const { t } = useTranslation();
  const classes = useStyles();
  const navBarClasses = useNavBarStyles();
  const titleClasses = useTitleStyles();

  const dispatch = useDispatch();

  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [search, setSearch] = useState("");

  const AllProfessionalDevelopmentActivities = useSelector((state) =>
      state.professionalDevelopmentActivities
          .AllProfessionalDevelopmentActivities
  );

  const persons = useSelector((state) => state.user.staffList)

  useEffect(() => {
    dispatch(fetchStaff())
    dispatch(fetchAllProfessionalDevelopmentActivities())
        .then(unwrapResult)
        .then((AllProfessionalDevelopmentActivities) => {
          setRows(AllProfessionalDevelopmentActivities);
        });
  }, []);

  const searchButton = navBarClasses.top + " " + navBarClasses.searchButton;

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  function onChangeActivitiesByOrganization(value) {
    let AllProfessionalDevelopment =
      AllProfessionalDevelopmentActivities &&
      AllProfessionalDevelopmentActivities.filter((ProfessionalDevelopment) => {
        if (!value && search === "") {
          return ProfessionalDevelopment;
        } else if (
          ProfessionalDevelopment.organization
            .toLowerCase()
            .includes(value.toLowerCase())
        ) {
          return ProfessionalDevelopment;
        }
      });
    setRows(AllProfessionalDevelopment);
  }

  function onChangeActivitiesByType(value) {
    let AllProfessionalDevelopment =
      AllProfessionalDevelopmentActivities &&
      AllProfessionalDevelopmentActivities.filter((ProfessionalDevelopment) => {
        if (!value) {
          return ProfessionalDevelopment;
        } else if (
          value &&
          ProfessionalDevelopment.type
            .toLowerCase()
            .includes(value.toLowerCase())
        ) {
          return ProfessionalDevelopment;
        }
      });
    setRows(AllProfessionalDevelopment);
  }

  function onChangeActivitiesByAuthors(value) {
    let AllProfessionalDevelopment =
      AllProfessionalDevelopmentActivities &&
      AllProfessionalDevelopmentActivities &&
      AllProfessionalDevelopmentActivities.authors_details &&
      AllProfessionalDevelopmentActivities.authors_details[0].filter(
        (ProfessionalDevelopment) => {
          if (!value) {
            return ProfessionalDevelopment;
          } else if (
            value &&
            ProfessionalDevelopment.type
              .toLowerCase()
              .includes(value.toLowerCase())
          ) {
            return ProfessionalDevelopment;
          } else if (
            ProfessionalDevelopment.name
              .toLowerCase()
              .includes(search.toLowerCase())
          ) {
            return ProfessionalDevelopment;
          }
        }
      );
    setRows(AllProfessionalDevelopment);
  }

  function onChangeActivitiesByName(value) {
    let AllProfessionalDevelopment =
      AllProfessionalDevelopmentActivities &&
      AllProfessionalDevelopmentActivities.filter((ProfessionalDevelopment) => {
        if (!value) {
          return ProfessionalDevelopment;
        } else if (
          value &&
          ProfessionalDevelopment.title
            .toLowerCase()
            .includes(value.toLowerCase())
        ) {
          return ProfessionalDevelopment;
        }
      });
    setRows(AllProfessionalDevelopment);
  }

  return (
    <div>
      <Breadcrumb separator=">">

        <Breadcrumb.Item>
          <Link to={`/citrine/faculty/Activities`}>{t("Activities")}</Link>{" "}
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/citrine/faculty/Activities/AllProfessionalDevelopmentActivities`}>
            {t("Professional Development Activities")}
          </Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <br></br>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <div>
          <Select
            allowClear
            placeholder="Type"
            optionFilterProp="children"
            onChange={onChangeActivitiesByType}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{
              marginRight: "20px",
              width: "200px",
              backgroundColor: "none",
              zIndex: "10000",
            }}
          >
            {AllProfessionalDevelopmentActivities &&
              AllProfessionalDevelopmentActivities.map(
                (ProfessionalDevelopment) => (
                  <Option
                    value={
                      ProfessionalDevelopment && ProfessionalDevelopment.type
                    }
                  >
                    {ProfessionalDevelopment && ProfessionalDevelopment.type}
                  </Option>
                )
              )}
          </Select>
          <Select
            allowClear
            placeholder="Organization"
            optionFilterProp="children"
            onChange={onChangeActivitiesByOrganization}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ marginRight: "20px", width: "200px" }}
          >
            {AllProfessionalDevelopmentActivities &&
              AllProfessionalDevelopmentActivities.map(
                (ProfessionalDevelopment) => (
                  <Option
                    value={
                      ProfessionalDevelopment && ProfessionalDevelopment.organization
                    }
                  >
                    {ProfessionalDevelopment && ProfessionalDevelopment.organization}
                  </Option>
                )
              )}
          </Select>
          <Select
            showSearch
            allowClear
            placeholder="Author"
            optionFilterProp="children"
            onChange={onChangeActivitiesByAuthors}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ marginRight: "20px", width: "200px" }}
          >
            {persons &&
              persons.map(
                (person) => (
                  <Option value={person && person.id} >
                    {`${person.first_name + " " + person.last_name}`}
                  </Option>
                )
              )}
          </Select>
        </div>
      </div>
      <div>
        <Box sx={{ mt: '10px', ml: '1200px', p: '20px', width: '300px' }}>
          <ViewListIcon style={{ cursor: 'pointer' }} />
          <TableViewIcon style={{ cursor: 'pointer' }} />
        </Box>
      </div>
      <Card>
        <div style={{ width: "100%", height: 460, padding: "10px" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            disableSelectionOnClick
            autoPageSize={true}
            columnBuffer={0}
            disableColumnMenu={true}
            showCellRightBorder
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 20, 80]}
            pagination
          />
        </div>
      </Card>
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  );
}

const columns = [
  {
    field: "title",
    headerName: "Title",
    width: 200,
    sortable: false,
  },
  {
    field: "type",
    headerName: "Type",
    width: 150,
    sortable: false,
  },
  {
    field: "authors",
    headerName: "Team members",
    width: 200,
    sortable: false,
    renderCell: (params) => (
      <div>
        {params.row.team_members_details.map((item) =>
          <Typography fullWidth display='block'>
            <GridItem>
              {item.first_name} { } {item.last_name}
            </GridItem>
          </Typography>
        )}
      </div>
    ),
  },
  {
    field: "start_date",
    headerName: "Start Date",
    width: 110,
    sortable: false,
  },
  {
    field: "end_date",
    headerName: "End Date",
    width: 110,
    sortable: false,
  },
  {
    field: "location",
    headerName: "Location",
    width: 100,
    sortable: false,
  },
  {
    field: "organization",
    headerName: "Organization",
    width: 120,
    sortable: false,
  },

  {
    field: "trainer",
    headerName: "Trainer",
    width: 150,
    sortable: false,
  },
  {
    field: "state",
    headerName: "State",
    width: 80,
    sortable: false,
  },
];
